// extracted by mini-css-extract-plugin
export var dropdownContainer = "_sc-0";
export var leftAlign = "_sc-4";
export var listItem = "_sc-2";
export var listItemWrapper = "_sc-1";
export var operationText = "_sc-3";